module.exports = __webpack_public_path__ + "96bee14d077d144e9ca4005854ecb5c3.jpg";